import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSuperAdmin = lazy(() => import("@/pages/admin/AdminSuperAdmin"));

export const Route = createFileRoute("/admin/super-admin")({
  component: AdminSuperAdmin,
});
